import Papa from 'papaparse';


interface IKeyValue {
    [key: string]: any
}

export const exportChatQueryAsCSV = (headers: Array<string>, data: Array<Array<any>>, fileName?: string) => {
    const csvData = convertQueryDataToArrayOfObject(headers, data)

    const csv = Papa.unparse(csvData, {
        delimiter: ';', 
        header: true,
    });

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    downloadBlob(blob, "csv")
}


export const exportChatQueryAsJSON = (headers: Array<string>, data: Array<Array<any>>) => {
    const convertedData = convertQueryDataToArrayOfObject(headers, data, false)
    const jsonData = JSON.stringify(convertedData, null, 2)
    const blob = new Blob([jsonData], { type: 'application/json;charset=utf-8;' });
    downloadBlob(blob, "json")
}


const convertQueryDataToArrayOfObject = (headers: Array<string>, data: Array<Array<any>>, stringify: boolean = true): Array<IKeyValue> => {

    const convertedData: Array<IKeyValue> = []

    data.forEach((item) => {
        const rowObject: IKeyValue = {}
        item.forEach((baseItem, index) => {
            const currentKey = headers[index]

            if (stringify)
                rowObject[currentKey] = JSON.stringify(baseItem)
            else
                rowObject[currentKey] = baseItem
        })

        convertedData.push(rowObject)
    })

    return convertedData
}


const downloadBlob = (blob: Blob, fileExtension: string, fileName?: string) => {
    const url = URL.createObjectURL(blob);
    
    const a = document.createElement('a');
    a.href = url;
    a.setAttribute('download', `${fileName || "galactic-barn-export"}.${fileExtension}`);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}